import { render, staticRenderFns } from "./HorizontalBrandTile.vue?vue&type=template&id=29646038&scoped=true&"
import script from "./HorizontalBrandTile.vue?vue&type=script&lang=ts&"
export * from "./HorizontalBrandTile.vue?vue&type=script&lang=ts&"
import style0 from "./HorizontalBrandTile.vue?vue&type=style&index=0&id=29646038&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29646038",
  null
  
)

export default component.exports